
<!-- Privacy modal desktop -->
<ng-container *ngIf="showPrivacyModal">
	<ng-container *ngIf="!isMobile else mobilePrivacyContent">
		<app-web-kamona-message-widget
		[modalType]="ModalType.CUSTOM"  
		>
			<ng-container *ngTemplateOutlet="privacyTemplate"></ng-container>
		</app-web-kamona-message-widget>
	</ng-container>
</ng-container>

<!-- Privacy modal mobile -->
<ng-template #mobilePrivacyContent>
  <app-mobile-kamona-message-widget
  [modalType]="ModalType.CUSTOM"
  (emitCancel)="handleClosePrivacyModal" 
  >
    <ng-container *ngTemplateOutlet="privacyTemplate">
    </ng-container>
  </app-mobile-kamona-message-widget>
</ng-template>

<!-- Terms modal desktop -->
<ng-container *ngIf="showTermsModal">
	<ng-container *ngIf="!isMobile else mobileTermsContent">
		<app-web-kamona-message-widget
		[modalType]="ModalType.CUSTOM"
		>
			<ng-container *ngTemplateOutlet="termsAndConditionsTemplate"></ng-container>
		</app-web-kamona-message-widget>
</ng-container>

</ng-container>

<!-- Terms modal mobile -->
<ng-template #mobileTermsContent>
  <app-mobile-kamona-message-widget
  [modalType]="ModalType.CUSTOM"
  (emitCancel)="handleCloseTermsModal" 
  >
    <ng-container *ngTemplateOutlet="termsAndConditionsTemplate">
    </ng-container>
  </app-mobile-kamona-message-widget>
</ng-template>



<ng-container *ngIf="showAlertModal">
	<ng-container *ngIf="!isMobile else mobileAlerts">
		<app-web-kamona-message-widget
		[modalType]="ModalType.CUSTOM"
		>
			<ng-container *ngTemplateOutlet="modalAlertContent">
			</ng-container>
		</app-web-kamona-message-widget>
	</ng-container>
</ng-container>


<ng-template #mobileAlerts>
  <app-mobile-kamona-message-widget
  [modalType]="ModalType.CUSTOM"
  >
    <ng-container *ngTemplateOutlet="modalAlertContent">
    </ng-container>
  </app-mobile-kamona-message-widget>
</ng-template>

<!-- modal alert content -->
<ng-template #modalAlertContent>
  <ng-container *ngIf="showAlertModal === 'rejected'">
		<ng-container *ngTemplateOutlet="rejectedTemplate"></ng-container>
	</ng-container>

	<ng-container *ngIf="showAlertModal === 'unauthorized'">
		<ng-container *ngTemplateOutlet="unauthorizedTemplate"></ng-container>
	</ng-container>

	<ng-container *ngIf="showAlertModal === 'unsupported'">
		<ng-container *ngTemplateOutlet="unsupportedTemplate"></ng-container>
	</ng-container>
</ng-template>



<div class="location-request-wrapper min-h-screen flex flex-col p-[20px] bg-[#f5f5f5]">
  <ng-container *ngTemplateOutlet="header"></ng-container>

  <ng-container *ngTemplateOutlet="body"></ng-container>


  <ng-container *ngTemplateOutlet="footer"></ng-container>
</div>

<ng-template #header>
	<div class="w-full flex flex-col md:flex-row justify-between md:items-center max-w-[1196px] mx-auto">
		<img src="assets/images/svgs/moniepoint-icon-and-label.svg" class="max-w-[240px] md:max-w-full">

	</div>
</ng-template>

<ng-template #body>
  <div class="body-wrapper max-w-[560px] mx-auto mt-[20px]">
    <div class="instructions bg-white rounded-2xl p-8">
      <img src="assets/images/svgs/request-location-access.svg" class="w-full" 
			data-test-id="location-request-banner"
			/>
  
      <div class="mt-6 mb-7 text-center">
        <h4 class="font-bold text-[28px] leading-[34.72px] mb-2 max-w-[335px] mx-auto"
				data-test-id="location-request-title"
				>Enable Location Access</h4>
        <p class="text-[12px] leading-[17.76px] max-w-[450px] mx-auto"
				data-test-id="location-request-description"
				>Moniepoint requires access to your location data to verify sign in attempts on your account and maintain account security.</p>
      </div>
  
      <div class="flex flex-col gap-6 items-center">
        <app-custom-button type="primary" text="Enable Location Access" class="w-full md:max-w-[300px]"
				data-test-id="location-request-accept-btn"
				(click)="handleRequestPermission()"
        ></app-custom-button>

        <app-custom-button
        state="lightsecondary"
        text="Do This Later" class="w-full md:max-w-[300px]"
				data-test-id="location-request-reject-btn"
				(click)="handleRejectRequest()"
        ></app-custom-button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #footer>
  <div class="w-full text-[14px] font-medium text-[#808080] leading-[17.36px] flex flex-col md:flex-row gap-6 md:gap-8 md:py-8 justify-center mt-auto">
    <span class="cursor-pointer" (click)="openPrivacy()">Privacy</span>
    <span class="cursor-pointer" (click)="openTermsAndConditions()">Terms & Conditions</span>
  </div>
</ng-template>

<ng-template #termsAndConditionsTemplate>
	<ng-container>
		<div class="flex flex-col gap-[24px] -mb-[8px]">
			<div class="flex flex-col gap-[8px]">
				<div class="leading-[29.76px] font-bold text-[24px] text-[#1A1A1A]">
					Terms and Conditions
				</div>
				<div class="leading-[19.6px] font-normal text-[14px] text-[#1A1A1A]">
					Please read through carefully
				</div>
			</div>
			<div class="overflow-y-scroll max-h-[475px]" id="terms-and-condition-content" [innerHTML]="termsAndConditions?.content"></div>
			<div class="flex items-center justify-center">
				<div (click)="handleCloseTermsModal()" class="bg-[#E6EEFD] w-[335px] cursor-pointer items-center h-[48px] gap-[4px] py-[6px] px-[16px] flex justify-center rounded-[8px]">
					<div class="text-[#0361F0] text-[14px] font-medium leading-[17.36px]">Close</div>
				</div>
			</div>
		</div>
	</ng-container>
</ng-template>

<ng-template #privacyTemplate>
	<ng-container>
		<div class="flex flex-col gap-[24px] -mb-[8px]">
			<div class="flex flex-col gap-[8px]">
				<div class="leading-[29.76px] font-bold text-[24px] text-[#1A1A1A]">
					Privacy Policy
				</div>
				<div class="leading-[19.6px] font-normal text-[14px] text-[#1A1A1A]">
					Please read through carefully
				</div>
			</div>
			<div class="overflow-y-scroll max-h-[475px]">
				<app-privacy></app-privacy>
			</div>
			<div class="flex items-center justify-center">
				<div (click)="handleClosePrivacyModal()" class="bg-[#E6EEFD] w-[335px] cursor-pointer items-center h-[48px] gap-[4px] py-[6px] px-[16px] flex justify-center rounded-[8px]">
					<div class="text-[#0361F0] text-[14px] font-medium leading-[17.36px]">Close</div>
				</div>
			</div>
		</div>
	</ng-container>
</ng-template>

<ng-template #rejectedTemplate>
  <div class="flex flex-col pt-[24px] px-[16px] gap-[32px]">
		<div class="flex justify-center">
			<img src="assets/images/svgs/error-lg.svg" class="w-[126px] h-[126px]" />
		</div>

    <h3 class="leading-[39.68px] text-black text-[32px] font-bold text-center max-w-[300px] mx-auto">Location access not granted</h3>

		<p class="text-[12px] text-[#333333] leading-[17.6px] text-center max-w-[300px] mx-auto">
			{{rejectedRequestMessage}}
		</p>

		<div class="flex flex-col gap-6 items-center">
      <app-custom-button type="primary" text="Give Moniepoint location access" class="w-full"
			(click)="handleDeniedLocation()"
      ></app-custom-button>
		</div>
	</div>
</ng-template>

<ng-template #unauthorizedTemplate>
  <div class="flex flex-col pt-[24px] px-[16px] gap-[32px]">
		<div class="flex justify-center">
			<img src="assets/images/svgs/error-lg.svg" class="w-[126px] h-[126px]" />
		</div>

    <h3 class="leading-[39.68px] text-black text-[32px] font-bold">
			Unauthorised Location Identified
		</h3>
		<p class="text-[12px] text-[#333333] leading-[17.6px]">
			We’ve identified a login from an unauthorised location. Check your location settings and try again, or contact Moniepoint support for help. 
		</p>

		<div class="flex flex-col gap-6 items-center">
      <app-custom-button type="primary" text="Try again" class="w-full"
      ></app-custom-button>
		</div>
	</div>
</ng-template>

<ng-template #unsupportedTemplate>
  <div class="flex flex-col pt-[24px] px-[16px] gap-[32px]">
		<div class="flex justify-center">
			<img src="assets/images/svgs/error-lg.svg" class="w-[126px] h-[126px]" />
		</div>

    <h3 class="leading-[39.68px] text-black text-[32px] font-bold">
			Unsupported Browser detected
		</h3>
		<p class="text-[12px] text-[#333333] leading-[17.6px]">
			We&apos;ve identified an unsupported browser version. Please update your browser or switch to a supported browser and try again.
		</p>
	</div>
</ng-template>